/**
 * Phone numbers as people read them. The server keeps E.164 (`+19735550142`);
 * a North American number shows as "(973) 555-0142", anything else as E.164.
 */
const NANP = /^\+1(\d{3})(\d{3})(\d{4})$/;

/**
 * A number as typed, in E.164 as the server keeps it, or null if it can't be
 * one: ten digits, or eleven starting with 1, are a North American number
 * ("(555) 555-0142", "1-555-555-0142"); one written with a + is another
 * country's ("+44 20 7946 0000"). The server's rule (backend/app/domain/
 * phones.py) reads more, and checks it again.
 */
export function normalizePhone(raw: string): string | null {
  const text = raw.trim();
  const digits = text.replace(/\D/g, "");
  if (digits.length < 7 || digits.length > 15 || /[a-z]/i.test(text)) {
    return null;
  }
  if (text.startsWith("+")) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : null;
}

export function formatPhone(e164: string): string {
  const match = NANP.exec(e164);
  return match ? `(${match[1] ?? ""}) ${match[2] ?? ""}-${match[3] ?? ""}` : e164;
}

/**
 * The number in a "Needs client" block's group key (`phone:+19735550142`,
 * ADR 0029), or null when the key isn't a phone number.
 */
export function phoneFromGroupKey(groupKey: string | null): string | null {
  if (groupKey?.startsWith("phone:") !== true) {
    return null;
  }
  return formatPhone(groupKey.slice("phone:".length));
}
